module.exports = __webpack_public_path__ + "img/mmi-about-photo-01-mighty-minds-scholar.e33fb74b.png";